import styled from "styled-components";

const ModalWrapper = styled.div`
  .ant-modal-body {
    padding: 0;
  }
`;

export { ModalWrapper };
